import styled from '@emotion/styled';
import { mq } from '~/shared/utils/mq';

const MobileLineBreak = styled.br(
  mq({
    display: ['block', 'none'],
  }),
);

export default MobileLineBreak;
